import React from "react";
import { Value } from "./core/Value";
import Common from './Common';

export default class DynamicValue extends React.Component<DynamicValue.Props, DynamicValue.State>
{

    value: Value;

    constructor(props: DynamicValue.Props)
    {
        super(props);

        this.value = Value.getNumber(props.id);

        this.state = {
            value: this.value.strValue
        };
    }


    componentDidMount(): void
    {
        this.value.register(this.onValueUpdate, this)
    }
    
    
    componentWillUnmount(): void
    {
        this.value.unregister(this.onValueUpdate, this)
    }


    onValueUpdate()
    {
        this.setState({
            value: this.value.strValue
        });
    }


    render()
    {
        return (
            <>
                {Common.formatCurrency(this.state.value, this.props.ignoreDecimals)}
            </>
        );
    }


}


export namespace DynamicValue
{


    export interface Props
    {
        id: ValueId;
        ignoreDecimals?: boolean;
    }


    export interface State
    {
        value: string;
    }


}